import { SurveyContext } from '../context/surveycontext';
import { useEffect, useContext } from 'react';

const SurveyQuestions = ({wlSurvey}) => {

    const {
        uniqueId,        
        questions,
        isLoading,
        isError,
        getSurveyQuestionsForId,
        setQuestions,
        submit
    } = useContext( SurveyContext );
   
    useEffect(() => {       
        
        const getSurveyQs = async () => {
                await getSurveyQuestionsForId({uniqueId}, wlSurvey);
            }

            getSurveyQs();
        }, [uniqueId]
    );

    function submitForm(event) {
        event.preventDefault();
        submit({ uniqueId }, { questions });

        return false;
    }

    function updateSurveyQuestion(event) {
        const selVal = event.target.value;
        const splitValues = selVal.split('-');

        const questionId = splitValues[0];
        const answerVal = splitValues[1];

        for (let i = 0; i < questions.length; i++) {
            if (questions[i].questionId === parseInt(questionId)) {
                questions[i].answer = parseInt(answerVal);
                setQuestions(questions);
                break;
            }
        }
    }

    if (!isLoading) {
        const answerChoices = ['5 - Strongly Agree','4 - Agree','3 - Neutral','2 - Disagree','1 - Strongly Disagree'];
        return (
            
            <div style={isError ? { display: 'none',paddingBottom: '50px' } : {paddingBottom: '50px'} }>
                <form onSubmit={submitForm}>
                    {
                        questions.map((q, index) => {
                            const answerNm = 'answer' + index;
                            return (
                                <div className='container-fluid' key={answerNm}>
                                    <div className='checkbox'>
                                        <h4 className='checkbox-heading mb-4'>{q.question}</h4>
                                        <div className='control-group' aria-required='true' required onChange={updateSurveyQuestion}>
                                            <label className={wlSurvey ? 'control-single-survey control-checkbox' : 'control control-checkbox'}>
                                                {answerChoices[0]}
                                                <input type='radio' required className={'cb' + index} id={'cb' + index} name={answerNm} value={q.questionId + '-5'} />
                                                <div className='control_indicator'></div>
                                            </label>
                                            <label className={wlSurvey ? 'control-single-survey control-checkbox' : 'control control-checkbox'}>
                                                {answerChoices[1]}
                                                <input type='radio' required className={'cb' + index} id={'cb' + index} name={answerNm} value={q.questionId + '-4'} />     
                                                <div className='control_indicator'></div>
                                            </label>
                                            <label className={wlSurvey ? 'control-single-survey control-checkbox' : 'control control-checkbox'}>
                                                {answerChoices[2]}
                                                <input type='radio' required className={'cb' + index} id={'cb' + index} name={answerNm} value={q.questionId + '-3'} />  
                                                <div className='control_indicator'></div>
                                            </label>
                                            <label className={wlSurvey ? 'control-single-survey control-checkbox' : 'control control-checkbox'}>
                                                {answerChoices[3]}
                                                <input type='radio' required className={'cb' + index} id={'cb' + index} name={answerNm} value={q.questionId + '-2'} />  
                                                <div className='control_indicator'></div>
                                            </label>
                                            <label className={wlSurvey ? 'control-single-survey control-checkbox' : 'control control-checkbox'}>
                                                {answerChoices[4]}
                                                <input type='radio' required className={'cb' + index} id={'cb' + index} name={answerNm} value={q.questionId + '-1'} />  
                                                <div className='control_indicator'></div>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                    <div className='contaner-fluid text-center pt-5'>
                        <button type='submit' className={wlSurvey ? 'submit-button-form-single-survey' : 'submit-button text-white'}>Submit</button>
                    </div>
                </form>
            </div>
           
        );
    }
    else {
        return <div>Loading...</div>
    }

};

export default SurveyQuestions;